import { PublicKey } from "@saberhq/solana-contrib";
import { SYRUP_ADDRESSES } from "./constants";
export const findLenderAddress = async (pool, owner, programId = SYRUP_ADDRESSES.Syrup) => {
    return await PublicKey.findProgramAddress([Buffer.from("lender"), pool.toBytes(), owner.toBytes()], programId);
};
//# sourceMappingURL=pda.js.map